module.exports = __webpack_public_path__ + "img/LoaderRing.36745a19.png";